import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Platform, AlertController } from '@ionic/angular';
import { environment } from '@environments/environment';
import { HTTP_HEADERS, HTTP_METHODS, ENCRYPTION, API_PATH,BASE_URL } from '@root/modules/common/services/service.constant';
import { EncryptionProviderService } from '@root/modules/common/services/encryption.service';
import { AuthService } from '@root/modules/common/services/auth.service';
import { ErrorHandler } from '@common/handlers/error.handler';
import { CommonService } from '@common/services/common.service';
import { Device } from '@ionic-native/device/ngx';


declare var window: any;
export abstract class AbstractService<T> {

  public http: HttpClient;

  public url: string;

  constructor(
    http: HttpClient,
    private encryptionProviderService: EncryptionProviderService,
    private platform: Platform,private alertController:AlertController, private commonService:CommonService,
    private device:Device) {
    this.http = http;
  }

  public request(options: {
    method: string;
    url: string;
    body?: any;
    headers?: {
      [header: string]: string | string[];
    };
    params?: {
      [param: string]: string | string[];
    };
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  }): Observable<any> {

    options.headers = options.headers ? { ...options.headers } : {};
    const contentType = options.headers[HTTP_HEADERS.CONTENT_TYPE];
    options.url = this.getFullUrl(options.url);
    if (!contentType) {
      options.headers[HTTP_HEADERS.CONTENT_TYPE] =
        'application/json;charset=utf-8';
    } else if (contentType === 'multipart/form-data') {
      delete options.headers[HTTP_HEADERS.CONTENT_TYPE];
    }

    let serverUrl = this.getServerUrl();
    this.platform.ready().then(() => {

      if (environment.sslEnabled) { // this.platform.is("cordova") && && window.plugins
        this.sslChecker(serverUrl);
      }
    });

    if (EncryptionProviderService.isEncription && options.method === HTTP_METHODS.POST && !options.url.includes('processTransaction') && !options.url.includes("/profile/image")) {
      options.body = !options.body ? {} : options.body;
      options.body.guid = this.generateGuid(options.url);
      options.body.timeStamp = Date.now();

      options.body = {
        eData: this.encryptionProviderService.encryptData(
          JSON.stringify(options.body)
        ),
      };
    }

    // set Accept only if not set
    if (!options.headers[HTTP_HEADERS.ACCEPT]) {
      options.headers[HTTP_HEADERS.ACCEPT] = 'application/json;charset=utf-8';
    }

    // direct execute check - download
    if (
      options.headers[HTTP_HEADERS.BLOB] &&
      options.method === HTTP_METHODS.GET
    ) {
      delete options.headers[HTTP_HEADERS.BLOB];
      options.responseType = 'blob';
    }

    // set session token if logged in user and if it is not PAYTM Api url
    if (AuthService.isLogged() && !options.url.includes('processTransaction')) {
      options.headers['session-token'] = AuthService.getSessionToken();
    }
    if(!options.url.includes('fetchkeys') && (this.commonService.getPlatformDetails().isAndroidApp || this.commonService.getPlatformDetails().isIosApp || this.commonService.getPlatformDetails().isIPad)){
      options.headers['device-id'] = this.platform.is('cordova') ? this.device.uuid : '';
      options.headers['device-os'] = this.platform.is('cordova') ? this.device.platform : '';
    }

    if (options.body instanceof FormData && options.method === 'POST') {
      delete options.headers[HTTP_HEADERS.CONTENT_TYPE];
    }

    return Observable.create((observer) => {
      this.http
        .request(options.method, options.url, {
          headers: options.headers,
          body: options.body,
          params: options.params,
          observe: 'response',
          responseType: options.responseType,
        })
        .pipe(timeout(60000))
        .subscribe(
          (data) => {
                const resp = data as HttpResponse<any>;
                const o = resp.body;
                if (o['eData']) {
                  const decryptRes = this.encryptionProviderService.decryptData(
                    o['eData']
                  );
                  observer.next(JSON.parse(decryptRes));
                } else {
                  observer.next(o);
                }


          },
          (error) => {
            observer.error(ErrorHandler.parseError(error.error));
            CommonService.requestTracker=[];
            CommonService.hideLoader();
          },
          () => observer.complete()
        );
    });
  }

  private generateGuid(url: string) {
    let result = '';
    const length = 32;
    const chars = ENCRYPTION.chars;
    for (let i = length; i > 0; --i) {
      result += chars[Math.round(Math.random() * (chars.length - 1))];
    }

    this.encryptionProviderService.setGuid({
      key: url,
      value: result,
    });

    return result;
  }

  private getFullUrl(url:string): string{
    return url.indexOf('http')===-1 ?  API_PATH+url : url;
  }

  private getServerUrl():string{
    return BASE_URL;
  }
  sslChecker(requestUrl) {
     let server = requestUrl;
        // let fingerprint = "CC 50 72 B9 D4 37 E7 23 85 E7 56 4D E4 CB 9B DF 4D 0D 3D B6 E7 B1 F7 72 89 B0 62 12 57 9A 38 EF"
        let fingerprint = "74 B0 6B 97 66 98 43 6C F1 66 0B 92 1F 62 86 7F 0D EB EF 6A 68 79 97 A6 38 4B DB DC C6 A2 12 A3"
        if (window.plugins.sslCertificateChecker) {
             window.plugins.sslCertificateChecker.check(
                (success: any) => this.successCallback(success),
                (error: any) => this.errorCallback(error),
                server,
                fingerprint
              );
        }
  }
         
   successCallback(message) {
    AuthService.setSslPinningInfo(true);
    console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<< (SSL certificate matches!!!) >>>>>>>>>>>>>>>>>>>>>>>>>>>");
  }

  errorCallback(message) {
    CommonService.hideLoader();
    if (message === "CONNECTION_NOT_SECURE") {
      AuthService.setSslPinningInfo(false);
      console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<< (SSL certificate does not match!!!) >>>>>>>>>>>>>>>>>>>>>>>>>>>");
        this.appLogoutOnBack("An SSL error has occurred and unable to establish secure connection to server.");
      return;
    } else if (message.indexOf("CONNECTION_FAILED") > - 1) {
      CommonService.hideLoader();
      this.offlineAlert("You are offline");
      console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<< (NETWORK ERROR) >>>>>>>>>>>>>>>>>>>>>>>>>>>");
    }
  }

  async appLogoutOnBack(subheader) {
    const sslPermissionModal = await this.alertController.create({
      header: "Authentication Error",
      subHeader: subheader,
      backdropDismiss: false,
      keyboardClose:true,
      cssClass:"sslAlert",
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'alert-backButton',
          handler: () => {
              navigator['app'].exitApp();
          },
          
        }
      ],
    });
    await sslPermissionModal.present();
  }
  async offlineAlert(subheader) {
    const sslPermissionModal = await this.alertController.create({
      subHeader: subheader,
      backdropDismiss: false,
      keyboardClose:true,
      cssClass:"sslAlert",
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'alert-backButton',
          handler: () => {
              navigator['app'].exitApp();
          },
          
        }
      ],
    });
    await sslPermissionModal.present();
  }
}
